module.exports = __webpack_public_path__ + "static/media/one-inch-unicorn.799d7c41.svg";